import { formatAddress, removeEmptyFields } from '../../../../../helper'

export const emptyBillingAddressValues = { name: null, companyName: null, street: null, house: null, city: null, zipCode: null }

export const toBillingAddressFormValues = billingAddress => billingAddress
	? {
		name: billingAddress.name || null,
		companyName: billingAddress.companyName || null,
		street: billingAddress.street || null,
		house: billingAddress.streetNumber || null,
		city: billingAddress.city || null,
		zipCode: billingAddress.postalCode || null,
	}
	: emptyBillingAddressValues

export const toCustomerFormValues = customer => ({
	...customer,
	address: formatAddress(customer.street, customer.streetNumber, customer.postalCode, customer.city),
	customerAddress: {
		city: customer.city || null,
		street: customer.street || null,
		house: customer.streetNumber || null,
		zipCode: customer.postalCode || null,
	},
	billingAddress: toBillingAddressFormValues(customer.billingAddress),
})

export const toBillingAddress = values => removeEmptyFields({
	companyName: values.companyName?.trim() || null,
	name: values.name?.trim() || null,
	street: values.street,
	streetNumber: values.house,
	city: values.city,
	postalCode: values.zipCode,
})

export const toRecipientAddress = customerAddress => ({
	address: formatAddress(customerAddress.street, customerAddress.house, customerAddress.zipCode, customerAddress.city),
	city: customerAddress.city,
	street: customerAddress.street,
	postalCode: customerAddress.zipCode,
	streetNumber: customerAddress.house,
})

export const toPaidOrderRecipient = ({ customerNumber, phoneNumber, email, companyName, name, customerAddress }, billingAddress, isFirma) => removeEmptyFields({
	customerNumber,
	phoneNumber,
	email,
	...(billingAddress ?? {
		companyName: isFirma ? companyName : null,
		name,
		street: customerAddress.street,
		streetNumber: customerAddress.house,
		city: customerAddress.city,
		postalCode: customerAddress.zipCode,
	}),
})
